import * as React from 'react';
import { UNSAFE_getMoment } from '../../../helpers/datetime';
import { fullMonths, getWeekDaysName } from '../../../helpers/localization/localizationUtils';
import { DatePickerI18n, DatePickerI18nContext } from '../../lab/DateRangePicker';

const moment = UNSAFE_getMoment();

export function DatePickerLabelsProvider(
  props: React.PropsWithChildren<{
    localizationData: Record<string, $TSFixMe>;
    translate: TranslateFn;
    weekdayFormat: string;
  }>
) {
  const datePickerI18nData: DatePickerI18n = React.useMemo(() => {
    return {
      months: fullMonths(props.translate, props.localizationData),
      weekDays:
        getWeekDaysName(props.weekdayFormat, props.translate, props.localizationData) ?? undefined,
      format: moment ? (date, format) => moment(date).format(format) : undefined,
      parse: moment ? (date, format) => moment(date, format).toDate() : undefined
    };
  }, [props.localizationData, props.translate, props.weekdayFormat]);

  return (
    <DatePickerI18nContext.Provider value={datePickerI18nData}>
      {props.children}
    </DatePickerI18nContext.Provider>
  );
}
